var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{attrs:{"value":_vm.value,"hidden":_vm.value==0}},[_c('div',{staticClass:"shop-card-icon",on:{"click":_vm.toShopCart}},[_c('img',{attrs:{"src":require("@/assets/img/shopcart-icon.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }